import React from 'react';
import { useTranslation } from 'react-i18next';

import CatalogRequestMetadata from 'components/CatalogRequestPage/CatalogRequestMetadata';
import { default as CatalogRequestComponent } from 'components/Account/CatalogRequest/CatalogRequest';
import MediaServer from 'components/Common/MediaServer/MediaServer';
import useGtmPageView from 'hooks/gtm/useGtmPageView';
import { ENV_MEDIAS_BASE_URL_ACCOUNT } from 'settings/env';
import { GTM_PAGE_OTHER } from 'settings/gtm/gtmPageView';

export default function CatalogRequest(): JSX.Element {
  const { t } = useTranslation(['catalogRequestPage']);
  const askCatalogUrlCms = ENV_MEDIAS_BASE_URL_ACCOUNT
    ? ENV_MEDIAS_BASE_URL_ACCOUNT + '/demande-catalogue.html'
    : undefined;

  useGtmPageView(GTM_PAGE_OTHER, `Afibel - ${t('CATALOG_REQUEST_META_TITLE')}`);

  return (
    <div>
      <CatalogRequestMetadata />
      <CatalogRequestComponent />
      {askCatalogUrlCms && (
        <MediaServer path={askCatalogUrlCms}>
          {({ render }) => <div>{render()}</div>}
        </MediaServer>
      )}
    </div>
  );
}
